<template>
	<div class="choose-group-container">
		<div class="logo-box">
			<img src="../../assets/images/logo.png" height="30" @click="goHome();" />
		</div>
		<div class="choose-group">
			<group-list></group-list>
		</div>
		<vFooter></vFooter>
	</div>
</template>

<script>
	import vFooter from '@/layout/vFooter.vue';
	import groupList from '@/components/groupList.vue';
	export default {
		components: {
			vFooter,
			groupList
		},
		data() {
			return {
				isBack: true //提交后改为false
			}
		},
		beforeRouteLeave(to, from, next) {
			if (to.path === "/login") {
				this.$store.dispatch("logout").then(result => {});
				next();
			} else {
				next();
			}
		},
		methods: {
			goHome() {
				this.$router.replace('/home');
			},
		},
	}
</script>

<style lang="scss" rel="stylesheet/scss">
	.choose-group-container {
		width: 100vw;
		min-width: 1240px;
		height: 100vh;
		background-color: #F5F7FA;
		display: flex;
		flex-direction: column;

		.logo-box {
			display: flex;
			justify-content: flex-start;
			align-items: center;
			padding-left: 20vw;
			height: 100px;
			font-size: 20px;
			font-weight: bold;
			color: #262728;
			cursor: pointer;
			background-color: #fff;
			flex-shrink: 0;
		}
		.choose-group {
			flex: 1;
			display: flex;
			align-items: center;
			justify-content: center;
		}
	}
</style>